module.exports = __webpack_public_path__ + "static/media/bogota.75d04675.jpeg";